module.exports = __webpack_public_path__ + "img/o_que_e_um_software_obra.4ba2e26f.jpg";